import moment from 'moment';

export function isSubscriptionValid(subscription: any) {
  return !subscription.expiredAt || moment(subscription.expiredAt) > moment();
}
